import React from 'react';
import { Users, Heart, Shield, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import { missionData } from '../data/mock';

const iconMap = { Users, Heart, Shield, TrendingUp };

const Mission = () => {
  return (
    <section id="mission" className="py-24 bg-cream" data-testid="mission-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <p className="uppercase text-xs md:text-sm tracking-[0.2em] font-bold text-forest mb-4 font-sans">
            Notre Mission
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6 tracking-tight">
            {missionData.title}
          </h2>
          <div className="w-16 h-1 bg-forest rounded-full mb-6" />
          <p className="text-base md:text-lg text-gray-600 leading-relaxed font-sans">
            {missionData.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {missionData.values.map((value, index) => {
            const Icon = iconMap[value.icon];
            return (
              <motion.div
                key={value.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group bg-white rounded-2xl p-8 border border-black/5 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-xl bg-navy/5 flex items-center justify-center mb-6 group-hover:bg-navy group-hover:text-white transition-all duration-300">
                  <Icon className="w-7 h-7 text-navy group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-serif font-bold text-navy mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed font-sans text-sm">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Mission;
